






































































import * as R from 'ramda'
import ExerciseButton from '@/components/exercises/components/ExerciseButton.vue'

export default {
  components: {
    ExerciseButton,
  },
  props: {
    exercise: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      openDialog: false,
      deleteCandidate: null,
    }
  },
  computed: {
    maxLength() {
      const baseDiffCount = 2
      return Math.max(
        this.exercise.strengtheningExercises ? this.exercise.strengtheningExercises.length : 0,
        this.exercise.cardioExercises ? this.exercise.cardioExercises.length + baseDiffCount : baseDiffCount
      )
    },
    transformedStrengtheningExercises() {
      const strExercises = R.pathOr([], ['strengtheningExercises'], this.exercise)
      const diff = this.maxLength - strExercises.length
      return [...strExercises, ...new Array(diff).fill(null)]
    },
    transformedCardioExercises() {
      const newCardioExercises = new Array(this.maxLength).fill(null)
      newCardioExercises[0] = {
        exerciseName: 'Beginning',
        bloodOxygenPerc: this.exercise.beginningBloodOxygenPerc,
        heartRateBpm: this.exercise.beginningHeartRateBpm,
        workload: null,
        timeMin: null,
        borgScale: null,
        o2Ipm: null,
        feedbackRating: null,
        feedbackMoreWorkLoad: null,
        comments: null,
      }

      newCardioExercises[newCardioExercises.length - 1] = {
        exerciseName: 'End',
        bloodOxygenPerc: this.exercise.endBloodOxygenPerc,
        heartRateBpm: this.exercise.endHeartRateBpm,
        workload: null,
        timeMin: null,
        borgScale: null,
        o2Ipm: null,
        feedbackRating: null,
        feedbackMoreWorkLoad: null,
        comments: null,
      }

      if (this.exercise.cardioExercises) {
        this.exercise.cardioExercises.forEach((cardioExercise, index) => {
          newCardioExercises[index + 1] = cardioExercise
        })
      }

      return newCardioExercises
    },
  },
  methods: {
    getCardioExProp(index, propName) {
      return R.pathOr('', [index, propName], this.transformedCardioExercises)
    },
    getStrExProp(index, propName) {
      return R.pathOr('', [index, propName], this.transformedStrengtheningExercises)
    },
  },
}
